/**
 * 人员卡片分享
 */
import React, { useCallback } from "react";
import { JoySpaceDocumentMessage, SessionType } from "@/types/chat";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { openUserCardModal } from "@/components/AddressBook/common";
import Context from "@/components/chat/context";
import { FocusSDK, isHomePageUrl } from "@/utils";
import { UserCardType } from "@/types/UserCard";

interface ShareUserCardProps {
  message: any;
  sessionType: SessionType;
  sendType?: MessageSendType;
  onReady?: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
  customFooter?: any;
}

function ShareUserCard(props: ShareUserCardProps) {
  const { message, sessionType, clsName, showFooter = true, customFooter } = props;

  const { currentEmployee, userData } = React.useContext(Context);
  const cardInfo = lodashGet(message, "data.0.sharecard", {});
  const openUserCard = useCallback(() => {
    const data = {
      userId: cardInfo?.pin || cardInfo?.userId,
      teamId: cardInfo?.teamId,
      app: cardInfo?.app
    } as any;
    if (isHomePageUrl()) {
      openUserCardModal(data);
    } else {
      FocusSDK.sendToMain("ai:openUserCard", {
        ...data,
        menuList: [
          "chat", // 聊天
          "voice", // 音频
          "video", // 视频
          "share" // 分享名片
        ]
      });
    }
  }, [cardInfo]);

  if (!cardInfo?.nickName) {
    return null;
  }

  return (
    <div className={`${clsName} content`}>
      <div className="s-user-card" onClick={openUserCard}>
        <div className="s-user-card-h-n">
          <HeadPortrait
            width="40px"
            height="40px"
            fontSize="13px"
            imgUrl={cardInfo?.avatar}
            name={cardInfo?.nickName}
            type={sessionType}
            isUnFollow={true}
            showType={HeadShowType.SHARE_USER_CARD}
            onItemClick={() => {
              return null;
            }}
          />
          <div className="info-wrap">
            <div className="name">{cardInfo?.nickName}</div>
            {cardInfo.deptName && (
              <div className="title">{`${cardInfo?.unitName || "暂无"}-${
                cardInfo.deptName || "暂无"
              }-${cardInfo.titleName || ""}`}</div>
            )}
          </div>
        </div>
        {showFooter ? (
          <>
            <div className="s-user-card-l" />
            <div className="s-user-card-s">个人名片</div>
          </>
        ) : null}
        {customFooter ? customFooter : null}
      </div>
    </div>
  );
}

export default ShareUserCard;
